export default __webpack_public_path__ + "static/media/mobNHLCardBg.54ea9f64.png";